import React, { useState, useEffect, useRef } from 'react';

const OurClients = () => {
    const [activeSlide, setActiveSlide] = useState(0);
    const sliderRef = useRef(null);

    const clients = [
        {
            name: "Odelia",
            logo: "O",
            logoColor: "#FF6B00",
            description: "Centro de estética avanzada"
        },
        {
            name: "Derma",
            logo: "D",
            logoColor: "#1B3B6F",
            description: "Clínica dermatológica"
        },
        {
            name: "Bello",
            logo: "B",
            logoColor: "#FF6B00",
            description: "Barbershop premium"
        },
        {
            name: "Wellness",
            logo: "W",
            logoColor: "#1B3B6F",
            description: "Centro de bienestar"
        },
        {
            name: "SpaZen",
            logo: "S",
            logoColor: "#FF6B00",
            description: "Spa & Masajes"
        }
    ];

    // Auto-rotate carousel
    useEffect(() => {
        const interval = setInterval(() => {
            setActiveSlide(prev => (prev + 1) % clients.length);
        }, 3000);

        return () => clearInterval(interval);
    }, [clients.length]);

    // Manually control carousel
    const nextSlide = () => {
        setActiveSlide(prev => (prev + 1) % clients.length);
    };

    const prevSlide = () => {
        setActiveSlide(prev => (prev - 1 + clients.length) % clients.length);
    };

    // Update carousel position when active slide changes
    useEffect(() => {
        if (sliderRef.current) {
            sliderRef.current.style.transform = `translateX(-${activeSlide * 100}%)`;
        }
    }, [activeSlide]);

    return (
        <section className="py-32 relative overflow-hidden bg-white" id="clientes">
            {/* Subtle background elements */}
            <div className="absolute inset-0 bg-gradient-to-b from-gray-50 via-white to-gray-50 opacity-70"></div>
            <div className="absolute top-40 left-10 w-72 h-72 bg-secondary/5 rounded-full blur-3xl"></div>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                <div className="text-center max-w-3xl mx-auto mb-16">
                    <h2 className="text-5xl font-bold mb-6 text-secondary">
                        Nuestros Clientes
                    </h2>
                    <p className="text-xl text-gray-600 mb-12">
                        Descubre cómo los mejores negocios aumentan su rendimiento con Grovi
                    </p>
                </div>

                {/* Client logos carousel */}
                <div className="text-center mb-12">
                    {/* Carousel container */}
                    <div className="relative max-w-4xl mx-auto overflow-hidden">
                        {/* Carousel track */}
                        <div
                            ref={sliderRef}
                            className="flex transition-transform duration-500 ease-out"
                        >
                            {clients.map((client, index) => (
                                <div key={index} className="w-full flex-shrink-0 flex flex-col items-center px-4">
                                    <div className="bg-white p-6 rounded-xl shadow-sm hover:shadow-md transition-shadow w-full max-w-xs mx-auto">
                                        <div className="h-20 w-20 mx-auto mb-4 rounded-full flex items-center justify-center text-white text-3xl font-bold"
                                            style={{ backgroundColor: client.logoColor }}>
                                            {client.logo}
                                        </div>
                                        <h4 className="text-lg font-bold text-gray-800">{client.name}</h4>
                                        <p className="text-gray-600 text-sm">{client.description}</p>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Navigation dots */}
                        <div className="flex justify-center mt-6 space-x-2">
                            {clients.map((_, index) => (
                                <button
                                    key={index}
                                    onClick={() => setActiveSlide(index)}
                                    className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${activeSlide === index
                                        ? 'bg-primary w-6'
                                        : 'bg-gray-300'
                                        }`}
                                    aria-label={`Go to slide ${index + 1}`}
                                />
                            ))}
                        </div>

                        {/* Navigation arrows */}
                        <button
                            className="absolute left-0 top-1/2 transform -translate-y-1/2 bg-white/80 p-2 rounded-full shadow-md z-10"
                            onClick={prevSlide}
                            aria-label="Previous client"
                        >
                            <svg className="w-5 h-5 text-gray-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                            </svg>
                        </button>
                        <button
                            className="absolute right-0 top-1/2 transform -translate-y-1/2 bg-white/80 p-2 rounded-full shadow-md z-10"
                            onClick={nextSlide}
                            aria-label="Next client"
                        >
                            <svg className="w-5 h-5 text-gray-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                            </svg>
                        </button>
                    </div>
                </div>

                {/* CTA to see demo */}
                <div className="text-center">
                    <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-8">
                        ¿Quieres ver Grovi en acción? Explora nuestro sitio de demostración completamente funcional.
                    </p>
                    <a href="#demo" className="inline-flex items-center px-8 py-4 bg-primary text-white font-semibold rounded-lg transition-all duration-300 hover:bg-primary-dark shadow-lg">
                        Ver Demo en Vivo
                        <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                        </svg>
                    </a>
                </div>
            </div>

            {/* Device mockup styling */}
            <style jsx="true">{`
                /* Browser mockup */
                .browser-mockup {
                    border-radius: 8px;
                    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
                    overflow: hidden;
                    max-width: 100%;
                    background: white;
                }
                
                .browser-bar {
                    background: #f1f3f5;
                    padding: 8px 12px;
                    display: flex;
                    align-items: center;
                    border-bottom: 1px solid #e9ecef;
                }
                
                .browser-controls {
                    display: flex;
                    gap: 6px;
                    margin-right: 16px;
                }
                
                .browser-control {
                    width: 12px;
                    height: 12px;
                    border-radius: 50%;
                }
                
                .browser-control.red { background-color: #ff5f56; }
                .browser-control.yellow { background-color: #ffbd2e; }
                .browser-control.green { background-color: #27c93f; }
                
                .browser-address {
                    flex: 1;
                    background: white;
                    border-radius: 4px;
                    padding: 4px 12px;
                    font-size: 14px;
                    color: #495057;
                    text-align: center;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                
                .browser-content {
                    height: 450px;
                    overflow: hidden;
                }
                
                .browser-iframe {
                    width: 100%;
                    height: 100%;
                    border: none;
                }
                
                /* Phone mockup */
                .phone-mockup {
                    position: relative;
                    max-width: 320px;
                    margin: 0 auto;
                    transform: perspective(1000px);
                    transition: all 0.5s ease;
                }
                
                .phone-frame {
                    position: relative;
                    width: 100%;
                    height: 650px;
                    background: #121212;
                    border-radius: 40px;
                    padding: 12px;
                    overflow: hidden;
                    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
                    border: 6px solid #2d2d2d;
                }
                
                .phone-notch {
                    position: absolute;
                    top: 0;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 150px;
                    height: 30px;
                    background: #121212;
                    border-bottom-left-radius: 20px;
                    border-bottom-right-radius: 20px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    z-index: 10;
                }
                
                .phone-speaker {
                    width: 60px;
                    height: 6px;
                    background: #2d2d2d;
                    border-radius: 3px;
                }
                
                .phone-camera {
                    position: absolute;
                    right: 30px;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 10px;
                    height: 10px;
                    background: #2d2d2d;
                    border-radius: 50%;
                }
                
                .phone-screen {
                    width: 100%;
                    height: 100%;
                    background: white;
                    border-radius: 30px;
                    overflow: hidden;
                    position: relative;
                }
                
                .phone-iframe {
                    width: 100%;
                    height: 100%;
                    border: none;
                }
                
                .phone-home-indicator {
                    position: absolute;
                    bottom: 10px;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 100px;
                    height: 5px;
                    background: rgba(0, 0, 0, 0.3);
                    border-radius: 3px;
                    z-index: 10;
                }
                
                .phone-shadow {
                    position: absolute;
                    top: 10px;
                    left: 10px;
                    width: calc(100% - 20px);
                    height: calc(100% - 20px);
                    border-radius: 40px;
                    box-shadow: 0 30px 60px rgba(0, 0, 0, 0.3);
                    z-index: -1;
                }
            `}</style>
        </section>
    );
};

export default OurClients;